/** Small pieces of the Finish sheet: the yes/no segment and the tappable "what this means" line. */
import { useId, useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/** A yes/no question as two pressed-state buttons (the reference's `.seg`), labelled by the question. */
export function YesNo({ id, label, value, onChange, help }: { id: string; label: string; value: boolean; onChange: (v: boolean) => void; help?: ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className="yn-row">
      <span className="yn-q">
        <span id={`${id}-q`}>{label}</span>
        {help}
      </span>
      <div className="seg" role="group" aria-labelledby={`${id}-q`} id={id} data-testid={id}>
        <button type="button" aria-pressed={value} onClick={() => onChange(true)}>
          {t('finish.yes')}
        </button>
        <button type="button" aria-pressed={!value} onClick={() => onChange(false)}>
          {t('finish.no')}
        </button>
      </div>
    </div>
  );
}

/** "What this means": a small button that shows (and reads) one line of plain words. */
export function WhatIs({ label, children }: { label: string; children: ReactNode }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <>
      <button type="button" className="whatis" aria-expanded={open} aria-controls={id} aria-label={t('finish.whatMeansOf', { label })} onClick={() => setOpen((o) => !o)}>
        ?
      </button>
      <span id={id} className="whatis-line" hidden={!open}>
        {children}
      </span>
    </>
  );
}
